/** Источник запроса за списком чатов или историей сообщений, пишется в логи ошибок */
export enum ERequestTrigger {
  /* первая загрузка списка чатов при монтировании, в том числе после выбора субагента и SSR-диплинка в архив или спам */
  ChatListInitialLoad = 'chatList:initialLoad',
  /* скролл списка чатов до конца */
  ChatListScroll = 'chatList:scroll',
  /* клик по вкладке раздела в TopMenu или MasterTabs */
  ChatListTabSwitch = 'chatList:tabSwitch',
  /* синхронизация вернула tooManyRecords, список перезагружается целиком */
  ChatListSyncTooManyRecords = 'chatList:syncTooManyRecords',
  /* открытие чата из списка или восстановление из history */
  ChatOpen = 'chat:open',
  /* чат возвращён из архива, раздел переключается на «Сообщения» */
  ChatRestoredFromArchive = 'chat:restoredFromArchive',
  /* чат разблокирован из спама, раздел переключается на «Сообщения» */
  ChatRestoredFromSpam = 'chat:restoredFromSpam',
  /* скролл вверх в окне чата */
  MessagesScrollUp = 'messages:scrollUp',
  /* клик по цитате или превью реплая */
  MessagesReplyQuoteClick = 'messages:replyQuoteClick',
  /* WS-событие chat по открытому чату из архива, раздел переключается на «Сообщения» */
  WsArchivedChatUpdated = 'ws:archivedChatUpdated',
  /* переподключение WS после закрытия сокета с кодом меньше 4000 */
  WsReconnectAfterClose = 'ws:reconnectAfterClose',
  /* переподключение WS по кнопке «Повторить» при упавшем сокете */
  WsReconnectByRetryClick = 'ws:reconnectByRetryClick',
  /* переподключение WS перед отправкой сообщения или подпиской на статус собеседника, если сокет закрыт */
  WsReconnectBeforeSend = 'ws:reconnectBeforeSend',
  /* переподключение WS после возврата фокуса или видимости вкладки */
  PageReconnectOnFocusReturn = 'page:reconnectOnFocusReturn',
}
